module.exports = __webpack_public_path__ + "static/faq-b62d0941dac4161a4c8013be1fcace1e.png";